document.addEventListener('DOMContentLoaded', () => {
    const accordionToggles = document.querySelectorAll('.accordion-toggle');

    accordionToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const content = toggle.closest('.accordion').querySelector('.accordion-content');
            if (content) {
                content.style.display = content.style.display === 'none' || content.style.display === '' ? 'block' : 'none';
                toggle.classList.toggle('rotate');
            } else {
                console.error('Accordion content not found for:', toggle);
            }
        });
    });
});

